import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";

import style from "../assets/css/page/DashboardControl.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faPlus,
  faShieldAlt,
  faTable,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../components/Modal";
import FormAddTeam from "../components/Form/FormAddTeam";
import TableGral from "../components/TableGral";
import Match from "../components/Match";
import FormAddMatch from "../components/Form/FormAddMatch";
import useGetTeams from "../hooks/useGetTeams";
import classnames from "classnames";

import { GET_TABLE, GET_MATCHES, GET_TOURNAMENTS } from "../graphql/queries";
import { useNavigate } from "react-router";

import { socket } from "../config/socket";
import Loading from "../components/Loading";
import LogoHeader from "../components/Header/LogoHeader";

import Swal from "sweetalert2";
import Button from "../components/Button/Button";
import ProxMatchs from "../components/ProxMatchs";
import FormUpdateNumRegister from "../components/Form/FormUpdateNumRegister";
import FormUpdateNumDay from "../components/Form/FormUpdateNumDay";

const modalStates = {
  addTeam: false,
  addMatch: false,
  editTeam: false,
  updateNumRegister: false,
  updateNumDay: false,
  updatePositionTeams: false,
};

function DashboardControl() {
  const { data, loading } = useQuery(GET_MATCHES, {});
  const tournaments = useQuery(GET_TOURNAMENTS);
  const [activeModals, setActiveModals] = useState(modalStates);
  const [teams, setTeams] = useState([]);
  // const [matches, setMatches] = useState(null);
  const [teamsOptions, setTeamOptions] = useState(null);
  const [teamsId, setTeamId] = useState(null);
  const [allTeams, setAllTeams] = useState(false);
  const [live, setLive] = useState(null);
  const [modalActive, setModalActive] = useState(false);
  const role = window.localStorage.getItem("role");
  const navigate = useNavigate();
  const { loadingTeam, getTeams } = useGetTeams();
  const table = useQuery(GET_TABLE);
  const [matchs, setMatchs] = useState([]);

  useEffect(() => {
    socket.on("hello", (res) => {
      console.log(res);
    });
  }, []);

  useEffect(() => {
    socket.on("newTeam", (res) => {
      console.log(res.team);
      setTeams((teams) => [...teams, res.team]);
    });
  }, []);

  useEffect(() => {
    if (role !== "Admin") {
      navigate("/");
    }
  }, [role]);

  useEffect(() => {
    if (!loading && data) {
      let matchOrder = [...data.matchs];
      matchOrder.sort(
        (a, b) =>
          a.day - b.day ||
          new Date(a.date).getTime() - new Date(b.date).getTime() ||
          a?.hour?.split(":")[0] - b?.hour?.split(":")[0]
      );
      setMatchs(matchOrder);
    }
  }, [loading, data]);

  useEffect(() => {
    // console.log("teams cargado");
    let isMounted = true;
    async function fetchTeams() {
      let teamsOptions = [];
      let teamsId = [];
      const teams = await getTeams();
      teams?.map((team) => {
        teamsOptions.push({
          value: team._id,
          label: team.name,
        });
        teamsId.push({
          id: team._id,
        });
        return null;
      });
      if (isMounted) {
        setTeams(teams);
        setTeamOptions(teamsOptions);
        setTeamId(teamsId);
      }
    }
    fetchTeams();

    return () => (isMounted = false);
  }, []);

  useEffect(() => {
    socket.on("teamUpdate", (res) => {
      // console.log("----------");
      // console.log("xd", teams);

      let newTeams = [...teams];
      console.log(newTeams);

      const objIndex = newTeams.findIndex((obj) => obj.id === res.team.id);
      let newTeam = { ...res.team };
      newTeams.splice(objIndex, 1, newTeam);

      setTeams(newTeams);
    });
  }, [teams]);

  if (
    loading ||
    loadingTeam ||
    table.loading ||
    tournaments.loading
  )
    return <Loading />;

  const changeModalState = (modal) => async () => {
    setActiveModals({ ...activeModals, [modal]: !activeModals[modal] });
    setModalActive(!modalActive);
  };

  const signOut = () => {
    try {
      Swal.fire({
        title: "¿Quieres cerrar sesión?",
        showDenyButton: true,
        // showCancelButton: true,
        confirmButtonText: "Si, cerrar sesión",
        denyButtonText: `Cancelar`,
      }).then((result) => {
        if (result.isConfirmed) {
          logoutAction();
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const logoutAction = () => {
    window.localStorage.clear();
    navigate("/");
  };

  return (
    <div
      className={
        modalActive
          ? classnames(style.container, style.noScroll)
          : style.container
      }
    >
      <div className={style.header}>
        <LogoHeader />
        <Button text="Cerrar sesión" onClick={signOut} />
      </div>
      <div
        className={
          allTeams
            ? classnames(style.contTeams, style.allteams)
            : style.contTeams
        }
      >
        <div className={style.addTeams}>
          <button
            className={style.btnAction}
            onClick={changeModalState("addTeam")}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
          <button
            className={classnames(style.btnAction, style.btnAllteams)}
            onClick={() => setAllTeams(!allTeams)}
          >
            <p className={allTeams ? style.iconUp : style.iconDown}>
              <FontAwesomeIcon icon={faChevronDown} />
            </p>
          </button>
        </div>
        <div className={style.itemTeams}>
          {teams &&
            teams.map((team, index) => (
              <ItemTeam
                key={index}
                name={team.shortName ? team.shortName : team.name}
                color={team.colorShirt ? team.colorShirt : "#ff4b4b"}
                changeModalState={changeModalState("editTeam")}
              />
            ))}
        </div>
      </div>
      <div className={style.control}>
        <div className={style.matchLive}>
          <div className={style.proxMatchs}>
            {matchs &&
              matchs.map((match) =>
                match.live ? (
                  <ProxMatchs
                    key={match.id}
                    match={match}
                    tournament={tournaments.data.tournaments[0].name}
                  />
                ) : null
              )}
          </div>
          <div className={style.actionsTournament}>
            <div className={style.itemAction}>
              <p className={style.textAction}>Jornada Actual</p>
              <button
                className={style.btnAction}
                onClick={changeModalState("updateNumRegister")}
              >
                <p className={style.iconDown}>{tournaments.data.tournaments[0].currentDay}</p>
              </button>
            </div>
            <div className={style.itemAction}>
              <p className={style.textAction}>Registro de jugadores</p>
              <button
                className={style.btnAction}
                onClick={changeModalState("updateNumDay")}
              >
                <p className={style.iconDown}>
                  <FontAwesomeIcon icon={faUsers} />
                </p>
              </button>
            </div>
            <div className={style.itemAction}>
              <p className={style.textAction}>Actualizar posiciones</p>
              <button
                className={style.btnAction}
                onClick={changeModalState("updatePositionTeams")}
              >
                <p className={style.iconDown}>
                  <FontAwesomeIcon icon={faTable} />
                </p>
              </button>
            </div>
            {/* <Button text="Registro de jugadores" onClick={signOut} />
            <Button text="Actualizar posiciones" onClick={signOut} /> */}
          </div>
        </div>
        <div className={style.content}>
          <div className={style.table}>
            <TableGral data={table.data?.generalTables} />
            {/* <TableGral /> */}
          </div>
          <div className={style.allMatchs}>
            <div className={style.newMatchs}>
              <p className={style.title}>Partidos</p>
              <div className={style.contBtn}>
                <p className={style.title}>Nuevo</p>
                <button
                  className={style.btnAction}
                  onClick={changeModalState("addMatch")}
                >
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </div>
            </div>
            <div className={style.matchs}>
              {matchs &&
                matchs.map(
                  (match) => (
                      <Match
                        key={match.id}
                        match={match}
                        admin={true}
                        teamsOptions={teamsOptions}
                        live={live}
                        setLive={setLive}
                        tournament={tournaments.data.tournaments[0].name}
                      />
                    )
                )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title="Registrar equipo"
        show={activeModals.addTeam}
        close={changeModalState("addTeam")}
      >
        <div className={style.contModal}>
          <FormAddTeam />
        </div>
      </Modal>
      <Modal
        title="Editar o eliminar equipo"
        show={activeModals.editTeam}
        close={changeModalState("editTeam")}
      >
        <div className={style.contModal}>
          <FormAddTeam btnDelete={true} />
        </div>
      </Modal>
      <Modal
        title="Registrar partido"
        show={activeModals.addMatch}
        close={changeModalState("addMatch")}
      >
        <div className={style.modalMatch}>
          <FormAddMatch options={teamsOptions} />
        </div>
      </Modal>
      <Modal
        title="Actualizar jornada actual"
        show={activeModals.updateNumRegister}
        close={changeModalState("updateNumRegister")}
      >
        <div className={style.contModalField}>
          <FormUpdateNumDay
            idTournament={tournaments.data.tournaments[0].id}
          />
        </div>
      </Modal>
      <Modal
        title="Actualizar número de jornada"
        show={activeModals.updateNumDay}
        close={changeModalState("updateNumDay")}
      >
        <div className={style.contModalField}>
          <FormUpdateNumRegister teams={teamsId} />
        </div>
      </Modal>
      <Modal
        title="Actualizar posiciones de equipos"
        show={activeModals.updatePositionTeams}
        close={changeModalState("updatePositionTeams")}
      >
        <div className={style.contModal}>
          <FormAddTeam />
        </div>
      </Modal>
    </div>
  );
}

const ItemTeam = ({ name, color, changeModalState }) => (
  <div className={style.team} onClick={changeModalState}>
    <p className={style.shield}>
      <FontAwesomeIcon icon={faShieldAlt} color={color} />
    </p>
    <p className={style.name}>{name}</p>
  </div>
);

export default DashboardControl;
